import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { Link } from 'gatsby';
import type { FC } from 'react';
import type { NodesEntity } from '../../../@types/gql/home';
import Image from '../../shared/image';
import { GitCommitHorizontal } from 'lucide-react';

const BlogCard: FC<NodesEntity> = ({
  ShortDescription,
  Slug,
  category,
  publishedAt,
  Thumbnail,
  Title,
}) => {
  return (
    <Link to={`/blog/${Slug}`} >
      <div className=''>
      <div
        className="relative lg:flex min-w-80 hover:-translate-y-1.5 transition-smooth overflow-hidden border border-solid rounded-xl"
        style={{
          borderColor: '#D9D9D9',
        }}
      >
       <div className='relative'>
        <div className='flex-shrink-0 h-[15rem] w-[20rem]'>
           <img alt="..." className="h-full w-full object-cover" src={Thumbnail?.url}/>
         </div>
         <p className="blog_tag flex gap-3 items-center absolute bottom-0 left-0 py-0.5 px-4 rounded-tr bg-black text-xs text-white bg-action-btn2">
          {category?(<>{category} <GitCommitHorizontal size={20} /></>):''}   <span className="text-xs">{new Date(publishedAt).toLocaleDateString('en', {
                dateStyle: 'long',
              })}</span>
        </p>
       </div>
       
        <div className="bg-white px-4 py-4">
         

          <p className="mb-4 line-clamp-2 text-xl font-bold" title={Title}>
            {Title}
          </p>

          <p
            className="font-light line-clamp-3 text-base font-normal leading-7 text-black"
            title={ShortDescription}
          >
            {ShortDescription}
          </p>
          <Link className="flex custombtn-color pt-2.5" to={`/blog/${Slug}`}>
            READ MORE <BsArrowRight className="font-bold text-2xl" />
          </Link>
        </div>
      </div>
      </div>
    </Link>
  );
};

export default BlogCard;
